import React from "react"
import "./Search.scss"
import PropTypes from "prop-types"

const Search = (props) => {
  return (
    <div className="Search">
      <label className="hidden" for="search">
        Search
      </label>
      <input
        id="search"
        type="text"
        placeholder="Search"
        onChange={props.handleChange}
        value={props.value}
      />
    </div>
  )
}

Search.propTypes = {
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string,
}

export default Search
